export default __webpack_public_path__ + "static/media/x.7ccbbb57.svg";